<template>
  <div>
    <v-row class="text-center mb-15" v-if="ecuDetails">
      <v-card
        class="mx-auto border textCard py-9 mt-5"
        min-width="300"
        tile
        elevation="0"
        outlined
      >
        <v-list-item two-line v-if="ecuDetails.plain_name">
          <v-list-item-content>
            <v-list-item-title>{{ ecuDetails.plain_name }}</v-list-item-title>
            <v-list-item-subtitle class="red--text"
              >Ecu name</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line v-if="ecuDetails.type_of_ecu">
          <v-list-item-content>
            <v-list-item-title> {{ ecuDetails.type_of_ecu }}</v-list-item-title>
            <v-list-item-subtitle class="red--text"
              >Type of ECU</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line v-if="ecuDetails.micro_name">
          <v-list-item-content>
            <v-list-item-title> {{ ecuDetails.micro_name }}</v-list-item-title>
            <v-list-item-subtitle class="red--text"
              >Micro name</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line v-if="ecuDetails.ecu_maker">
          <v-list-item-content>
            <v-list-item-title>
              {{ ecuDetails.ecu_maker.name }}</v-list-item-title
            >
            <v-list-item-subtitle class="red--text">
              Brand name</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <ErrorInfo ref="ErrorInfo" />
    </v-row>
    <Progress v-else />
  </div>
</template>

<script>
import EcuService from "../../../utils/services/ecu.service";
import ErrorInfo from "@/components/shared/ErrorInfo.vue";
import Progress from "@/components/shared/Progress.vue";
export default {
  components: {
    ErrorInfo,
    Progress,
  },
  props: {
    id: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      brand: this.$route.params.brand,
      ecu: this.$route.params.ecu,
      ecuDetails: null,
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      return EcuService.getEcus(null, 1, null, this.ecu)
        .then((response) => {
          this.ecuDetails = response.collection[0];
        })
        .catch((error) => {
          this.$router.push("/");
          this.$refs.ErrorInfo.catchError(error);
        });
    },
  },
};
</script>



